module.exports = __webpack_public_path__ + "static/media/AoA_CloseUp_8.b548a7ae.jpg";